import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "checkbox-component p-2" }
const _hoisted_2 = ["innerHTML"]

import { ref, watch, onMounted } from 'vue'
import { answerItemBodyParser } from "../../../../helpers/question-parser"
import AnswerItem from "../../../../common/AnswerItem"


export default /*@__PURE__*/_defineComponent({
  __name: 'QuestionCheckBox',
  props: {
    list: { default: () => [] },
    value: { default: () => [] },
    trueBgr: { default: '' },
    falseBgr: { default: '' },
    readonly: { type: Boolean, default: false },
    fieldType: { default: 'radio' },
    callBackChange: { type: Function, default: () => {} },
    color: { default: '' }
  },
  setup(__props: any) {

const props = __props

const checkbox = ref<any[]>([])

watch(() => props.value, (val, oldVal) => {
  if (val !== oldVal) {
    checkbox.value = val
  }
})

onMounted(() => {
  if (props.value.length) {
    checkbox.value = props.value
  }
})

const getStyle = (item: AnswerItem) => {
  if (props.trueBgr && item.correct) {
    return {
      'background-color': props.trueBgr
    }
  }
  if (props.falseBgr && !item.correct) {
    return {
      'background-color': props.falseBgr
    }
  }
  if (props.color != '') {
    return {
      'background-color': props.color
    }
  }
}

const onCheckboxChange = (val: any) => {
  props.callBackChange(val)
}

const parserBody = (answerItem: AnswerItem) => {
  return answerItemBodyParser(answerItem.body)
}

return (_ctx: any,_cache: any) => {
  const _component_v_checkbox = _resolveComponent("v-checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        style: _normalizeStyle(getStyle(item))
      }, [
        (item.name != 'point')
          ? (_openBlock(), _createBlock(_component_v_checkbox, {
              key: 0,
              modelValue: checkbox.value,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((checkbox).value = $event)),
                onCheckboxChange
              ],
              color: "success",
              value: item.body,
              "hide-details": "",
              class: "p-2 mt-0",
              readonly: __props.readonly
            }, {
              label: _withCtx(() => [
                _createElementVNode("div", {
                  innerHTML: parserBody(item)
                }, null, 8 /* PROPS */, _hoisted_2)
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "value", "readonly"]))
          : _createCommentVNode("v-if", true)
      ], 4 /* STYLE */))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}
}

})